import type { ChordDegree, ChordKind } from './chords';
import { STANDARD_TUNING, chromaOf, openStringMidi, type Position, type Tuning } from './fretboard';
import {
  CAGED_ORDER,
  cagedShape,
  type CagedQuality,
  type CagedShapeName,
  type Degree,
} from './shapes';

/**
 * Movable chord voicings for the chord drills (D8 chord tones, D36 naming):
 * the CAGED shapes of major, minor and 7 chords (shapes.ts), plus the common
 * maj7, m7, m7♭5, sus2 and sus4 voicings, each named after its CAGED family.
 * Placed at the nut they are the open chords (C x32010, Am7 x02010, Gmaj7
 * 320002, Dsus4 xx0233 …); moved up the neck, the E and A shapes are the
 * barre chords. Offsets are frets from the root on `rootString`, in standard
 * tuning. Every voicing has its root as its lowest note.
 */

export interface TemplateNote {
  readonly string: number;
  readonly offset: number;
  readonly degree: ChordDegree;
}

export interface VoicingTemplate {
  readonly shape: CagedShapeName;
  readonly kind: ChordKind;
  readonly rootString: number;
  /** Low string first. */
  readonly notes: readonly TemplateNote[];
}

                                                              
                 
                 
                   
  

                                                   
         
           
           
           
           
  

/** A CAGED shape from theory, as offsets from its root. */
                                                                                                    
                                                            
          
          
         
                             
                                
                       
                                  
                                     
        
    
 

type Row = readonly (readonly [string: number, offset: number, degree: ChordDegree])[];

                  
                        
                  
                     
            
                    
          
          
         
               
                                                                                
    
 

/**
 * The open maj7, m7, m7♭5 and sus chords each shape is named after, and
 * their barre forms. The CAGED families with no common voicing of a kind are
 * left out.
 */
                                            
                                                                          
                            
                
                
                
                
                
                
     
                            
                
                
                
                
                
     
                            
                
                 
                 
                 
                 
     
                            
                
                
                
                
     
                            
                
                 
                 
                 
                 
                 
     
                                                                            
                          
                
                
                 
                 
                
                
     
                          
                
                
                 
                 
                
     
                          
                
                
                 
                 
     
                                                                     
                            
                
                 
                 
                  
     
                            
                
                 
                 
                 
     
                            
                
                 
                 
                 
     
                                              
                            
                
                
                
                
                
                
     
                            
                
                
                
                
                
     
                            
                
                
                
                
     
                                
                            
                
                
                
                
                
     
                            
                
                
                
                
     
  

/** The chord kinds with movable voicings here. */
                                                   
          
          
      
         
       
         
         
         
  

/** Every shape of a kind, in CAGED order; none for a kind with no voicings. */
export function templatesFor(kind: ChordKind): VoicingTemplate[] {
  const quality = CAGED_KIND[kind];
  if (quality) return CAGED_ORDER.map((shape) => fromCaged(shape, kind, quality));
  return CAGED_ORDER.flatMap((shape) => OTHERS.filter((t) => t.kind === kind && t.shape === shape));
}

export interface PlacedNote extends Position {
  readonly degree: ChordDegree;
}

/** Frets to add on a string so a standard-tuning note keeps its pitch in `tuning`. */
                                                                           
                                                                                         
 

/**
 * Every placement of the template at `root` whose notes all lie in frets
 * 0–`maxFret`, lowest first. In another tuning each note keeps its pitch and
 * moves along its string (drop D adds two frets on string 6).
 */
                           
                     
               
                 
                  
                   
                                                                  
                                                          
                                 
                                                                       
                                       
                       
                                                              
                       
        
                                                                              
   
             
 

import { CAGED_KIND } from "/Users/pookey/Documents/personal/Projects.nosync.noindex/guitar.nosync/app/src/theory/voicings.ts?split=0";
import { fromCaged } from "/Users/pookey/Documents/personal/Projects.nosync.noindex/guitar.nosync/app/src/theory/voicings.ts?split=2";
import { OTHERS } from "/Users/pookey/Documents/personal/Projects.nosync.noindex/guitar.nosync/app/src/theory/voicings.ts?split=4";
